/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { useIntl } from 'react-intl-next';

import { cssMap, jsx } from '@atlaskit/css';
import { Box, Flex, Stack } from '@atlaskit/primitives/compiled';
import Skeleton from '@atlaskit/skeleton';
import { token } from '@atlaskit/tokens';
import VisuallyHidden from '@atlaskit/visually-hidden';

import messages from './messages';

const DEFAULT_MENU_SKELETON_HEIGHT = 40;
const DEFAULT_AVATAR_HEIGHT = 20;
const DEFAULT_CONTENT_HEIGHT = 9;
const DEFAULT_BORDER_RADIUS = 3;

type MenuSkeletonItemProps = {
	testId?: string;
	avatarHeight?: number;
	contentHeight?: number;
};

const menuSkeletonStyles = cssMap({
	wrapper: {
		height: `${DEFAULT_MENU_SKELETON_HEIGHT}px`,
		width: '100%',
		paddingLeft: token('space.050'),
		paddingRight: token('space.050'),
	},
	avatar: {
		paddingLeft: token('space.025'),
	},
});

export const MenuSkeletonItem = ({
	testId,
	avatarHeight = DEFAULT_AVATAR_HEIGHT,
	contentHeight = DEFAULT_CONTENT_HEIGHT,
}: MenuSkeletonItemProps) => {
	const { formatMessage } = useIntl();
	return (
		<Stack xcss={menuSkeletonStyles.wrapper} alignBlock="center" testId={testId}>
			<Flex alignItems="center" gap="space.200">
				<Box xcss={menuSkeletonStyles.avatar}>
					<Skeleton
						width={avatarHeight}
						height={avatarHeight}
						borderRadius={DEFAULT_BORDER_RADIUS}
						isShimmering
					/>
				</Box>
				<Skeleton width="64%" height={contentHeight} isShimmering />
			</Flex>
			<VisuallyHidden>{formatMessage(messages.menuItemLoading)}</VisuallyHidden>
		</Stack>
	);
};
